import { render, staticRenderFns } from "./ConfirmDeleteProduct.vue?vue&type=template&id=44c7d510&scoped=true&"
import script from "./ConfirmDeleteProduct.vue?vue&type=script&lang=ts&"
export * from "./ConfirmDeleteProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c7d510",
  null
  
)

export default component.exports